import { Component, OnInit, OnDestroy } from '@angular/core';
import { Notification } from '@models/release-notes/notification';
import { ProfileNotificationService } from './profile-notification/profile-notification.service';
import { Subscription } from 'rxjs';
import { HeaderService } from '../header.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  notifications: Notification[];
  isMiniProfileActive: boolean = false;
  subs: Subscription[] = [];

  constructor(
    private notificationService: ProfileNotificationService,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.fetchNotificatioins();
    this.subs.push(
      this.headerService.headerStates$().subscribe((headerStates: { [key: string]: boolean }) => {
        if (headerStates) {
          this.isMiniProfileActive = headerStates.isMiniProfileActive;
        }
      })
    );
  }

  /**
  * Populates notification array | sets active notifications true | sets notifications total
  * @returns no return
  */
  fetchNotificatioins() {
    this.notificationService.getNotifications().subscribe(notifications => {
      this.notifications = notifications.filter(notification => notification.type === 'release').map((notification) => {
        const notificationStorageId = this.notificationTag(notification);
        if (localStorage.getItem(notificationStorageId)) {
          notification.read = true;
        }
        return notification;
      }).filter((notification: Notification) => !notification.read);
    });
  }

  notificationTag(notification: Notification) {
    return `notification-${notification.id}`;
  }

  /**
  * Sets notifications to localstorage if not already in existence | sets active notifications false
  * @returns no return
  */
  markNotificationsAsRead() {
    if (this.notifications) {
      this.notifications.forEach(notification => {
        let notificationStorageId = this.notificationTag(notification);
        localStorage.setItem(notificationStorageId, notification.message);
      });
      this.notifications = [];
    }
  }

  sendHeaderStateUpdate(headerStates: { [key: string]: boolean }): void {
    this.headerService.updateHeaderStates(headerStates);
  }

  handleDismissActiveItems() {
    this.isMiniProfileActive = false;
  }

  handleNavItemClick(event: Event, dropdownType: string) {
    if (dropdownType === 'mini-profile') {
      this.isMiniProfileActive = !this.isMiniProfileActive;
    } else {
      this.handleDismissActiveItems();
    }

    this.sendHeaderStateUpdate({
      isMiniProfileActive: this.isMiniProfileActive
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
